import { Modal as AntdModal } from "antd";

export const Modal = ({ ...restProps }) => {
  return (
    <AntdModal
      centered
      mask={{ closable: false }}
      destroyOnHidden
      aria-modal="true"
      {...restProps}
    />
  );
};
